// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconUpload } from '@ni/nimble-components/dist/esm/icons/upload';
import { wrap } from '../utilities/react-wrapper';

export { type IconUpload };
export const NimbleIconUpload = wrap(IconUpload);